export interface ICustomerAddressState {
  addresses: ICustomerAddressModel[]
}

export interface ICreatedCustomerAddressModel {
  addressInfo:IAddressModel;
  addressType: AddressTypeEnum;
}
export interface ICustomerAddressModel {
  id: number;
  addressInfo:IAddressModel;
  addressType: AddressTypeEnum;
}
export interface IAddressModel{
  firstName: string;
  lastName: string;
  phoneNumber: string;
  street: string;
  wardCode: string;
  wardName: string;
  districtCode: string;
  districtName: string;
  provinceCode: string;
  provinceName: string;
  countryCode: string;
  countryName: string;
  stateCode: string;
  stateName: string;
  postalCode: string;
}
export enum AddressTypeEnum {
  Shipping,
  Billing
}
